module.exports = __webpack_public_path__ + "static/media/casa.03bc9eda.svg";